<template>
  <h1>History</h1>
</template>